import React from 'react';

// ============================================
// ICONS
// ============================================

export const Icons = {
  folder: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
  progress: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>,
  user: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  file: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/></svg>,
  document: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  edit: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  check: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>,
  plus: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  trash: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  download: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  upload: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>,
  refresh: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
  mail: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  phone: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  globe: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  briefcase: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
  book: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
  image: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>,
  pdf: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15h6"/></svg>,
  pencil: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>,
  radar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/><line x1="12" y1="2" x2="12" y2="4"/></svg>,
};

// ============================================
// DEFAULT TEMPLATE
// ============================================

export const DEFAULT_TEMPLATE = {
  name: 'Immigration Case Progress',
  milestones: [
    {
      id: 'initial',
      title: 'Initial Contact',
      order: 1,
      steps: [
        { id: 's1', text: 'First consultation', status: 'pending' },
        { id: 's2', text: 'Understand needs', status: 'pending' }
      ]
    },
    {
      id: 'gather',
      title: 'Gather Info',
      order: 2,
      steps: [
        { id: 's1', text: 'Personal details', status: 'pending' },
        { id: 's2', text: 'Education history', status: 'pending' },
        { id: 's3', text: 'Work experience', status: 'pending' }
      ]
    },
    {
      id: 'pathway',
      title: 'Choose Pathway',
      order: 3,
      steps: [
        { id: 's1', text: 'Evaluate options', status: 'pending' },
        { id: 's2', text: 'Select best path', status: 'pending' }
      ]
    },
    {
      id: 'documents',
      title: 'Forms',
      order: 4,
      steps: [
        { id: 's1', text: 'Passport & ID', status: 'pending' },
        { id: 's2', text: 'Certificates', status: 'pending' },
        { id: 's3', text: 'Employment docs', status: 'pending' },
        { id: 's4', text: 'Police clearance', status: 'pending' }
      ]
    },
    {
      id: 'review',
      title: 'Expert Review',
      order: 5,
      steps: [
        { id: 's1', text: 'Verify documents', status: 'pending' },
        { id: 's2', text: 'Case assessment', status: 'pending' }
      ]
    },
    {
      id: 'submit',
      title: 'Submit',
      order: 6,
      steps: [
        { id: 's1', text: 'Prepare application', status: 'pending' },
        { id: 's2', text: 'Final review', status: 'pending' },
        { id: 's3', text: 'Submit', status: 'pending' }
      ]
    }
  ]
};

// ============================================
// HELPER FUNCTIONS
// ============================================

export const getFileType = (filename) => {
  if (!filename) return 'other';
  const ext = filename.split('.').pop()?.toLowerCase();
  if (['pdf'].includes(ext)) return 'pdf';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) return 'image';
  if (['doc', 'docx', 'txt', 'rtf'].includes(ext)) return 'doc';
  return 'other';
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

// ============================================
// HELPER FUNCTIONS
// ============================================

/**
 * Extracts clean file name from a full path/key
 * Removes: directory path, timestamp prefix (e.g., "1767021516940_")
 * Handles UUID-style names by extracting just the extension
 * Example: "695110720db1e4e641f495f1/1767021516940_Certification_John_Henry.pdf" 
 *       -> "Certification_John_Henry.pdf"
 */
export const getCleanFileName = (fileName) => {
  if (!fileName) return 'Unknown File';
  
  let cleanName = fileName;
  
  // Remove directory path (everything before last /)
  if (cleanName.includes('/')) {
    cleanName = cleanName.substring(cleanName.lastIndexOf('/') + 1);
  }
  
  // Remove timestamp prefix (13-digit timestamp followed by underscore)
  // Pattern: 1767021516940_filename.pdf -> filename.pdf
  const timestampMatch = cleanName.match(/^\d{10,14}_(.+)$/);
  if (timestampMatch && timestampMatch[1]) {
    cleanName = timestampMatch[1];
  }
  
  // Check if name is a UUID pattern (e.g., e9f11ab9-4510-4a76-b7c9-d1498955e526.pdf)
  // If so, just show "Document" + extension
  const uuidPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\./i;
  if (uuidPattern.test(cleanName)) {
    const ext = cleanName.split('.').pop()?.toUpperCase() || 'FILE';
    cleanName = `Document.${ext.toLowerCase()}`;
  }
  
  return cleanName || 'Unknown File';
};

// ============================================
// AVATAR HELPERS (matching UserList initials avatar)
// ============================================

export const AVATAR_COLORS = [
  '#6366f1', '#8b5cf6', '#a855f7', '#ec4899', '#ef4444',
  '#f97316', '#eab308', '#22c55e', '#14b8a6', '#06b6d4',
  '#3b82f6', '#6d28d9', '#db2777', '#059669', '#0891b2',
];

export const getInitials = (name) => {
  if (!name || name === 'Widget User' || name === 'widget') return '?';
  const clean = name.replace(/\(inferred\)/gi, '').trim();
  if (clean.includes('@')) return clean[0];
  const parts = clean.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0];
  return parts[0][0] + parts[parts.length - 1][0];
};

export const getAvatarColor = (name) => {
  if (!name) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const generateId = () => `id_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
